module.exports = __webpack_public_path__ + "img/heart.e47c271c.svg";